import { sanityImage } from '@/utils/sanityImage';
import { Box, Container, Grid, useMediaQuery } from '@chakra-ui/react';
import Image from 'next/image';
import { FC, useMemo, useState } from 'react';
import { BsArrowDownCircle } from 'react-icons/bs';
import Lightbox, { Slide } from 'yet-another-react-lightbox';
import { ButtonLink } from '../ButtonLink';
import { MotionBox } from '../MotionBox';
import { SectionTitle } from '../SectionTitle';
import styles from './Gallery.module.css';
import { GalleryProps } from './Gallery.props';

const Gallery: FC<GalleryProps> = ({ images, link, sectionTitle }) => {
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isSmallerThan540] = useMediaQuery('(max-width: 540px)');


  const handleImageClick = (index: number) => {
    setCurrentImageIndex(index);
    setIsLightBoxOpen(true);
  };


  const lightBoxSlides=useMemo<Slide[]>(() => images?.map((item) => ({
    src: sanityImage(item)?.width(1920).height(1200).url() || ''
  })) ||[],[images]);

  return (
    <Box className={styles.wrapper} p={{ base: '10px 0', md: '30px 0' }} mt={{ base: '50px', md: '80px' }} as="section">
      <Container maxW={{ base: '1140px' }}>
        <SectionTitle data={sectionTitle} />
        {images && Array.isArray(images) && (
          <Grid
            mt={{ base: 20, md: 50 }}
            templateColumns={{ base: 'unset', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }}
            gap={6}
          >
            {images.map((image, index) => {
              const delay = isSmallerThan540 ? 0.2 : 0.2 * index;


              return (
                <MotionBox
                  key={image?._key}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay:delay>0.5?0.5:delay }}
                  onClick={() => handleImageClick(index)}
                >
                  <Image
                    src={sanityImage(image)?.width(350).height(350).url() || ''}
                    height={350}
                    width={350}
                    className={styles.image}
                    alt="Gallery image"
                  />
                </MotionBox>
              );
            })}
          </Grid>
        )}
        {link && link.url && (
          <Box textAlign="center" mt={{ base: 20, md: 50 }}>
            <ButtonLink link={link} type="primary" icon={<BsArrowDownCircle/>} />
          </Box>
        )}
      </Container>
      <Lightbox
        open={isLightBoxOpen}
        index={currentImageIndex}
        close={() => setIsLightBoxOpen(false)}
        slides={lightBoxSlides}
      />
    </Box>
  );
};

export { Gallery };
